"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconGmail = void 0;
var React = __importStar(require("react"));
var IconGmail = function (props) { return (React.createElement("svg", __assign({ width: "34px", height: "34px", viewBox: "0 0 34 34" }, props),
    React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        React.createElement("g", null,
            React.createElement("rect", { id: "Background", fill: "#EEEDEA", x: 0, y: 0, width: 34, height: 34, rx: 4 }),
            React.createElement("polygon", { id: "Fill-7", fill: "#E7E4D7", points: "7.775 12.6033 7.775 26.0743 27.137 26.0743 27.137 12.6713 17.456 19.3393" }),
            React.createElement("polygon", { id: "Fill-9", fill: "#B8B7AE", points: "7.775 26.0745 17.456 19.3395 17.412 19.3075 7.775 25.9275" }),
            React.createElement("polygon", { id: "Fill-11", fill: "#B7B6AD", points: "27.1368 12.6711 27.1418 26.0741 17.4558 19.3391" }),
            React.createElement("path", { d: "M29.9796,10.6399 L29.9826,24.0299 C29.9336,25.5179 29.2896,26.0489 27.1416,26.0749 L27.1366,12.6709 L29.9796,10.6399 Z", id: "Fill-13", fill: "#B2392F" }),
            React.createElement("polygon", { id: "Fill-38", fill: "#F7F5ED", points: "7.0465 7.9998 17.4555 15.7178 27.9325 7.9998" }),
            React.createElement("path", { d: "M27.9327,7.9998 C29.0587,7.9998 29.9797,8.9208 29.9797,10.0468 L29.9797,10.6398 L27.1357,12.6708 L17.4557,19.3388 L7.7747,12.6038 L7.7747,26.0748 L7.0467,26.0748 C5.9207,26.0748 4.9997,25.1538 4.9997,24.0288 L4.9997,10.0468 C4.9997,8.9218 5.9207,7.9998 7.0467,7.9998 L17.4557,15.7178 L27.9327,7.9998 Z", id: "Fill-1", fill: "#E75A4D" }))))); };
exports.IconGmail = IconGmail;
exports.IconGmail.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconGmail;
